// extracted by mini-css-extract-plugin
export default {"fullWidthContainer":"Layout_fullWidthContainer__A9nIw"};